<template>
  <!-- name: '我要捐-我的捐赠-捐赠详情' -->
  <div class="myDonateDetailWrap">
    <div class="baseInfoBox">
      <span class="tagClass">捐赠编号</span>
      <h3>
        {{ $route.query.number }}<span>{{ projectObj.statusText }}</span>
      </h3>
      <span class="dateClass"> 捐赠日期 {{ projectObj.date }} </span>
    </div>
    <SwiperBanner :bannerList="projectObj.imgList" />
    <h2>{{ projectObj.name }}</h2>
    <p class="profileClass" v-html="projectObj.profile"></p>
    <div class="stateBox" style="display: none;">
      <div class="daysClass">
        <img
          src="https://img.bbalt.cn/imgh5/donate/icon_home.svg"
          alt=""
        />募集天数 {{ projectObj.days }}天
      </div>
      <div class="progressBox" style="display: none;">
        <div
          class="progressClass"
          :style="`width:${
            projectObj.curNum === 0
              ? 50
              : (projectObj.curNum / projectObj.total) * 100
          }%`"
        >
          已捐{{ projectObj.curNum }}件
        </div>

        <div
          class="lackClass"
          :style="`width:${
            projectObj.total === 0
              ? 50
              : (1 - projectObj.curNum / projectObj.total) * 100
          }%`"
        >
          缺少{{ Number(projectObj.total - projectObj.curNum) }}件
        </div>
      </div>
    </div>
    <div class="linkBox" style="display: none;">
      <p>
        <span class="labelClass">联系人：</span>
        <span class="textClass">{{ projectObj.linkman }}</span>
      </p>
      <p>
        <span class="labelClass">联系电话：</span
        ><span class="textClass">{{ projectObj.linkPhone }}</span>
      </p>
      <p>
        <span class="labelClass">收件地址：</span
        ><span class="textClass">{{ projectObj.recAddres }}</span>
        <img src="https://img.bbalt.cn/imgh5/userCenter/icon_help.svg" alt="" />
      </p>
    </div>
    <h4 class="titleClass" v-if="projectObj.type === 1">
      <span class="lineClass"></span>衣物捐赠详情
    </h4>
    <h4 class="titleClass" v-else>
      <span class="lineClass"></span>物品捐赠详情
    </h4>
    <div class="tableBox" v-if="projectObj.type === 1">
      <div class="thBox">
        <span>姓名</span>
        <span>身高</span>
        <span>性别</span>
        <span>季节</span>
        <span>数量</span>
      </div>
      <div
        class="trClass"
        v-for="(item, index) in projectObj.tableList"
        :key="index"
      >
        <span>{{ item.name }}</span>
        <span>{{ item.sizeHeight }}</span>
        <span>{{ item.sex }}</span>
        <span>{{ item.season }}</span>
        <span>{{ item.pledgedCount }}</span>
      </div>
    </div>
    <div v-else class="tableBox">
      <div class="thBox">
        <span>姓名</span>
        <span>分类</span>
        <span>名称</span>
        <span>数量</span>
      </div>
      <div
        class="trClass"
        v-for="(item, index) in projectObj.tableList"
        :key="index"
      >
        <span>{{ item.name }}</span>
        <span>{{ item.nameCn }}</span>
        <span>{{ item.goodsName }}</span>
        <span>{{ item.pledgedCount }}</span>
      </div>
    </div>
    <h4 v-if="projectObj.expressType != 2" class="titleClass">
      <span class="lineClass"></span>快递
    </h4>
    <p
      v-show="projectObj.expressType != 2"
      class="textPClass"
      v-for="item in projectObj.expressList"
      :key="item.id"
    >
      <span>{{ item.code }}</span>
    </p>
    <h4 v-if="projectObj.expressType == 2" class="titleClass">
      <span class="lineClass"></span>送货上门
    </h4>
    <div v-if="projectObj.expressType == 2" class="cardAddress">
      <div class="infoBox">
        <p>请在7天之内，将捐赠包裹送到以下地址：</p>
        <p class="addressClass">
          {{ receiverObj.province }}{{ receiverObj.district
          }}{{ receiverObj.addressDetail }}
        </p>
        <p>
          {{ receiverObj.name }}&nbsp;
          {{ receiverObj.mobile }}
        </p>
      </div>
    </div>
    <h4 class="titleClass"><span class="lineClass"></span>质检反馈</h4>
    <p class="textPClass">{{ projectObj.backDetails }}</p>
  </div>
</template>

<script>
import SwiperBanner from "@/components/SwiperBanner.vue";
import mixin from "@/utils/mixin.js";
import { donateDetail } from "@/api/donate";
import { getReceiverAddress } from "@/api/other";
export default {
  mixins: [mixin],
  components: { SwiperBanner },
  data() {
    return {
      projectObj: {
        number: this.$route.query.number,
        status: "",
        date: "",
        imgList: [],
        name: "",
        profile: "",
        days: "",
        total: 0,
        curNum: 0,
        lackNum: 0,
        linkman: "",
        linkPhone: "",
        recAddres: "",
        tableList: [],
        sendAddres: "",
        feedback: "",
        expressList: [],
        expressType: this.$route.query.expressType,
        type: "",
        backDetails: ''
      },
      receiverObj: {
        name: "",
        mobile: "",
        province: "",
        district: "",
        addressDetail: "",
      },
    };
  },
  created() {
    this.init();
  },
  methods: {
    init() {
      // 通过number查询捐赠详情数据
      donateDetail({ number: this.projectObj.number }).then((res) => {
        console.log(res);
        if (res.code === 200) {
          this.projectObj.date = res.content.donateDate;
          this.projectObj.statusText = res.content.statusText;
          res.content.imageList.forEach((item) => {
            this.projectObj.imgList.push({ url: item });
          });
          this.projectObj.days = res.content.days;
          this.projectObj.linkman = res.content.linkMan;
          this.projectObj.linkPhone = res.content.linkPhone;
          this.projectObj.recAddres = res.content.receiveAddress;
          this.projectObj.sendAddres = res.content.receiveAddress;
          this.projectObj.tableList = res.content.tableList;
          this.projectObj.curNum = res.content.curNum;
          this.projectObj.total = res.content.total;
          this.projectObj.expressList = res.content.donateLogisticsInfos;
          this.projectObj.type = res.content.type;
          this.projectObj.expressType = res.content.expressType;
          this.projectObj.backDetails = res.content.backDetails;
        }
      });
      getReceiverAddress().then((res) => {
        if (res.code === 200) {
          this.receiverObj = res.content;
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.myDonateDetailWrap {
  height: calc(100% - 100px);
  width: 100%;
  overflow: auto;
  padding: 0px 32px;
  padding-bottom: 37px;
  border-top: 1px solid #ededed;
  display: inline-block;
  font-family: PingFangSC, PingFang SC;
  background-color: #fff;

  .baseInfoBox {
    margin-bottom: 56px;
    border-bottom: 1px solid #ededed;
    padding-bottom: 40px;
    .tagClass {
      border: 1px solid #fe66a6;
      font-size: 22px;
      font-weight: 400;
      color: #fe66a6;
      margin-top: 39px;
      background: rgba(254, 102, 166, 0.08);
      border-radius: 4px;
      display: inline-block;
      text-align: center;
      padding: 5px;
    }
    h3 {
      margin-top: 16px;
      font-size: 36px;
      font-weight: 600;
      color: #333333;
      display: flex;
      justify-content: space-between;
      span {
        font-size: 32px;
        font-weight: 400;
        color: #679fd2;
      }
    }
    .dateClass {
      font-size: 24px;
      font-weight: 400;
      color: #666666;
      margin-top: 16px;
    }
  }
  .cardAddress {
    user-select: all;
  }
  h2 {
    font-size: 36px;
    font-weight: 600;
    color: #333333;
    margin-top: 56px;
  }
  .profileClass {
    margin: 32px 0px;
    font-size: 26px;
    font-weight: 400;
    color: #333333;
    line-height: 40px;
  }
  .stateBox {
    width: 100%;
    height: 160px;
    margin-top: 32px;
    margin-bottom: 56px;
    background-image: url("https://img.bbalt.cn/imgh5/donate/bg_state.svg");
    background-repeat: no-repeat;
    background-size: 100% 100%;
    display: flex;
    flex-flow: column;
    justify-content: center;
    .daysClass {
      margin: 0px 32px;
      height: 36px;
      font-size: 28px;
      font-weight: 600;
      color: #563144;
      line-height: 36px;
      display: flex;
      justify-content: flex-start;
      align-items: center;
      margin-top: 28px;
      img {
        width: 30px;
        height: 30px;
        margin-right: 21px;
      }
    }
    .progressBox {
      width: calc(100% - 64px);
      height: 48px;
      background: #ffffff;
      border-radius: 24px;
      margin: 16px 32px 32px 32px;
      display: flex;
      justify-content: space-between;
      font-size: 24px;
      font-weight: 400;
      color: #fe66a6;
      line-height: 48px;
      .progressClass {
        height: 100%;
        background: #fe66a6;
        border-radius: 24px;
        color: #ffffff;
        padding-left: 24px;
      }
      .lackClass {
        text-align: center;
        min-width: 15%;
      }
    }
  }

  .linkBox {
    font-size: 26px;
    font-weight: 400;
    color: #333333;
    line-height: 40px;
    p {
      display: flex;
      .labelClass {
        width: 150px;
        display: inline-block;
        text-align: left;
      }
      .textClass {
        max-width: 445px;
      }
      img {
        width: 30px;
        height: 30px;
        margin-left: 69px;
      }
    }
  }
  .titleClass {
    height: 46px;
    font-size: 36px;
    font-weight: 600;
    color: #333333;
    line-height: 46px;
    margin-top: 40px;
    margin-bottom: 24px;
    display: inline-block;
    .lineClass {
      width: 8px;
      height: 24px;
      background: #fe66a6;
      border-radius: 4px;
      display: inline-block;
      margin-right: 8px;
    }
  }
  .tableBox {
    margin-bottom: 40px;
    font-size: 26px;
    font-weight: 400;
    color: #999999;
    .thBox,
    .trClass {
      height: 104px;
      display: flex;
      border-bottom: 1px solid #e6e6e6;
      align-items: center;

      span {
        min-width: 110px;
        margin-left: 23px;
        &:first-child {
          width: 160px;
        }
      }
    }
    .trClass {
      color: #333333;
    }
  }
  .textPClass {
    margin-bottom: 40px;
    display: flex;
    font-size: 26px;
    font-weight: 400;
    color: #333333;
    span {
      display: inline-block;
      max-width: 542px;
    }
  }
}
</style>
